import { AxiosError } from 'axios';

export const isAbortError = (error: AxiosError) => {
  return (
    error?.code === 'ERR_CANCELED' ||
    error?.name === 'CanceledError' ||
    error?.name === 'AbortError'
  );
};
